import createAction from "../components/operational/createAction"

export const getProductWithCategoryId = async({sourceId,limit,type})=>{
    const sourceType = type == 'category' ? "categoryIdList" : "brandIdList"
    const response = await createAction({
        method: 'post',
        path: `/searchProductsByCategoryIdList`,
        showPreLoader: false,
        isFileUploading: false,
        hideToastMessages:true,
        data: {
            sourceId,
            limit:Number(limit),
            sourceType
        }
    });

    if (response?.error) return

    const resultData = response?.result?.resultData

    return resultData
}

const getProductWithBrandId = ()=>{
    
}